document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.cookiesBarWrapper');
  if (!wrapper) return;
  const closeBtn = document.querySelector('.cookiesBarWrapper__close');
  const understandBtn = document.querySelector('.cookiesBarBtnLink');
  const cookieAccepted = document.cookie.includes('mdsCookies=');
  if (!cookieAccepted) {
    wrapper.classList.add('showCookies');
  }
  function closeBar() {
    wrapper.classList.remove('showCookies');
    document.cookie =
      'mdsCookies=true; max-age=' +
      (60 * 60 * 24 * 7) +
      '; path=/';
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', closeBar);
  }
  if (understandBtn) {
    understandBtn.addEventListener('click', closeBar);
  }
});